export default __webpack_public_path__ + "static/media/thumbnail1.Conflict.d0569c0c.jpg";